@import 'styles/mixins';
@import 'styles/variables';

.root {
  height: 32px;
  display: inline-flex;
  align-items: center;
  padding-right: 8px;
  padding-left: 3px;
  background: $white;
  border-radius: 20px;
  @include md-regular;
  color: $grey-90;
  border: 1px solid $gray-10;
  flex-shrink: 0;
  margin-top: 2px;
  margin-bottom: 2px;
  column-gap: 8px;
  max-width: 100%;
}

.removeButton {
  display: flex;
  align-items: center;
  & svg {
    fill: $gray-40;
  }
}

.assignedItems {
  display: flex;
  @include md-regular;
  color: $grey-50;
  align-items: center;
  min-width: max-content;
}

.separator {
  height: 20px;
  width: 1px;
  background: $grey-10;
}

.title {
  @include line-clamp;
}
